export const ANNOUNCEMENTS = 'md_announcements_GLOBAL';